/**
 * Roulette europeenne, 37 cases (0 a 36, un seul zero).
 *
 * IMPORTANT : ce fichier est bundle dans le client, donc PUBLIC. Contrairement
 * aux poids des rouleaux de `slots.ts`, cela ne pose ici AUCUN probleme :
 * la disposition du cylindre, les couleurs et les cotes de chaque mise sont
 * une information publique, imprimee sur tout tapis de roulette physique. Le
 * SEUL secret reste le tirage lui-meme (packages/functions/src/lib/fair.ts),
 * jamais la table des gains.
 *
 * La legalite d'une mise (un "carre" doit vraiment former un carre sur le
 * tapis, etc.) est en revanche une regle de JEU, pas une donnee : elle vit
 * exclusivement dans le moteur serveur (games/roulette/engine.ts), qui est la
 * seule source de verite pour accepter ou refuser une mise.
 */
/** Nombre de cases du cylindre europeen. */
export const ROULETTE_POCKET_COUNT = 37;
/** Tous les numeros du cylindre, dans l'ordre croissant (pas l'ordre physique). */
export const ROULETTE_NUMBERS = Array.from({ length: ROULETTE_POCKET_COUNT }, (_unused, index) => index);
/**
 * Disposition reelle des couleurs sur un cylindre europeen. Le zero est vert,
 * tout le reste alterne selon ce jeu de 18 numeros rouges (l'autre moitie de
 * 1-36 est noire).
 */
export const ROULETTE_RED_NUMBERS = new Set([
    1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
]);
/** Couleur d'un numero. `n` hors [0, 36] renvoie `'green'` par defaut sans jeter. */
export function rouletteColor(n) {
    if (n === 0)
        return 'green';
    return ROULETTE_RED_NUMBERS.has(n) ? 'red' : 'black';
}
// ---------------------------------------------------------------------------
// Mises
// ---------------------------------------------------------------------------
export const ROULETTE_BET_KINDS = [
    'straight',
    'split',
    'street',
    'corner',
    'sixline',
    'dozen',
    'column',
    'red',
    'black',
    'even',
    'odd',
    'low',
    'high',
];
/**
 * Cotes affichees "X pour 1" (profit hors mise initiale), telles qu'imprimees
 * sur un tapis. Le CREDIT total verse sur une mise gagnante est
 * `montant * (cote + 1)` : la mise initiale revient avec son gain, comme sur
 * une vraie table. Ce sont ces cotes qui donnent le RTP theorique 36/37 pour
 * absolument chaque type de mise (verifie par enumeration exacte des 37
 * issues dans engine.test.ts) :
 *   - plein   : 1 numero  sur 37 -> 1/37 * 36  = 36/37
 *   - cheval  : 2 numeros sur 37 -> 2/37 * 18  = 36/37
 *   - transversale : 3/37 * 12   = 36/37
 *   - carre   : 4/37 * 9         = 36/37
 *   - sixain  : 6/37 * 6         = 36/37
 *   - douzaine/colonne : 12/37 * 3 = 36/37
 *   - chances simples  : 18/37 * 2 = 36/37
 */
export const ROULETTE_ODDS = {
    straight: 35,
    split: 17,
    street: 11,
    corner: 8,
    sixline: 5,
    dozen: 2,
    column: 2,
    red: 1,
    black: 1,
    even: 1,
    odd: 1,
    low: 1,
    high: 1,
};
/** RTP theorique, identique pour toutes les mises d'une roulette europeenne. */
export const ROULETTE_RTP = 36 / 37;
//# sourceMappingURL=roulette.js.map